/**
 * What the PDApp access list asks before removing an app grant, from the removal's
 * dry run (`miniappApi.previewRevoke`).
 *
 *  - `losing`  — other editors would lose the ability to edit the app: name them.
 *  - `none`    — nobody else loses it; remove without asking. A 4xx dry run is a
 *                REFUSAL of the very removal: skip the prompt, the real removal
 *                shows the refusal.
 *  - `unknown` — the dry run itself failed (network, 5xx): we can't say who'd lose
 *                edit access, so ask generically rather than silently skip the warning.
 */
export type RevokeConfirm =
  | { kind: 'none' }
  | { kind: 'losing'; names: string[] }
  | { kind: 'unknown' }

type Preview = { losesEditAccess?: Array<{ name: string | null; email: string; isYou: boolean }> }

export async function planRevokeConfirm(dryRun: () => Promise<Preview>): Promise<RevokeConfirm> {
  let preview: Preview
  try {
    preview = await dryRun()
  } catch (err) {
    const status = (err as { status?: unknown } | null)?.status
    if (typeof status === 'number' && status >= 400 && status < 500) return { kind: 'none' }
    return { kind: 'unknown' }
  }
  const names = (preview?.losesEditAccess ?? []).filter(p => !p.isYou).map(p => p.name || p.email)
  return names.length > 0 ? { kind: 'losing', names } : { kind: 'none' }
}
